// import axios from "axios";
import  api  from "../utils/request";

import { getAccessToken } from "../utils/tokens";

export const commonHeaders = {
  "Content-Type": "application/json"
  // "Access-Control-Allow-Headers": "Content-Type",
  // "Access-Control-Allow-Origin": "*",
  // "Access-Control-Allow-Methods": "*"
};



export const sendRequest = async (args) => {
  let bearerToken;
  try {
    const { url, headers, noAuth, data, serverCookie = "" } = args;
    bearerToken = serverCookie || (noAuth ? null : getAccessToken());
    const headerParams = { ...commonHeaders, ...headers };
    if (!noAuth && bearerToken) {
      headerParams.Authorization = `JWT ${bearerToken}`;
    }

    const options = {
      ...args,
      headers: headerParams,
      url: url,
    };

    if (data) {
      options.data = data;
    }

    // const response = await axios(options);
    const response = await api(options);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response; // backend error response
    } else {
      return {
        status: "error",
        message: error.message || "An unknown error occurred",
        config: error.config || args, // Return the request config for debugging
        isAxiosError: error.isAxiosError || false, // Flag to know if it's an axios error
      };
    }
  }
};


export const getRequest = async (args) => {
  const { data, headers, error, status } = await sendRequest({
    ...args,
    method: "get"
  });
  if (status === 200) {
    return { data, error: null, headers, status };
  }
  return { data, error: error || data, status };
};

export const postRequest = async (args) => {
  const { data, headers, error, status } = await sendRequest({
    ...args,
    method: "post"
  });

  if ([200, 201, 204].indexOf(status) > -1) {
    return { data, error: null, headers, status };
  }
  return { data: null, error: error || data, status };
};

export const patchRequest = async (args) => {
  const { data, headers, error, status } = await sendRequest({
    ...args,
    method: "patch"
  });
  if ([200, 201, 204].indexOf(status) > -1) {
    return { data, error: null, headers, status };
  }
  return { data: null, error: error || data, status };
};

export const deleteRequest = async (args) => {
  const { data, error, status, headers } = await sendRequest({
    ...args,
    method: "delete"
  });
  if ([200, 201, 204].indexOf(status) > -1) {
    return { data, error: null, headers, status };
  }
  return { data: null, error: error || data, status };
};

export const putRequest = async (args) => {
  const { data, error, status, headers } = await sendRequest({
    ...args,
    method: "put"
  });
  if ([200, 201, 204].indexOf(status) > -1) {
    return { data, error: null, headers, status };
  }
  return { data: null, error: error || data, status };
};
